"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
export function useInView(options) {
  const $ = _c(6);
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  let t0;
  let t1;
  if ($[0] !== isVisible || $[1] !== options) {
    t0 = () => {
      if (!ref.current || isVisible) {
        return;
      }
      const io = new IntersectionObserver(t2 => {
        const [entry] = t2;
        if (entry?.isIntersecting) {
          setIsVisible(true);
          io.disconnect();
        }
      }, {
        rootMargin: "1000px 0px",
        ...options
      });
      io.observe(ref.current);
      return () => io.disconnect();
    };
    t1 = [options, isVisible];
    $[0] = isVisible;
    $[1] = options;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] !== isVisible) {
    t2 = [ref, isVisible];
    $[4] = isVisible;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}